export default __webpack_public_path__ + "static/media/berny.5d221314.png";